import HomeAnimation from "./Components/HomeAnimation"

document.addEventListener('DOMContentLoaded', () => {
    let root = {}
    root.homeAnimation = new HomeAnimation(root, [])
    root.homeAnimation.run()
}, false)
